import * as yup from "yup";
import styles from "../usermanagement.module.css";
import {Button, Col, Container, Form, Row, Spinner, Tab, Tabs} from "react-bootstrap";
import {Formik} from "formik";
import {useContext, useEffect, useState} from "react";
import {BackendContext} from "../../../context/Backend";
import {useSubmit} from "react-router-dom";
import {useNavigate} from "react-router";
import {useTranslation} from "react-i18next";
import {isAxiosError} from "axios";

export const InviteForm = (props) =>{

    const backend = useContext(BackendContext);
    const submit = useSubmit();
    const navigate = useNavigate();
    const [languageList,setLanguageList] = useState([]);
    const {t} = useTranslation();

    useEffect(()=>{
        setLanguageList([<option key={"0"}>{t('system.dropdownSelect')}</option>,...backend.languages.map((val) => <option key={val.id} value={val.id}>{val.language}</option>)]);
    },[backend.languages])

    const schema = yup.object().shape(
        {
            tabInvite: yup.object().shape({
                email: yup.string().email().required(),
                language: yup.number().required()
            }),
        }
    );

    const handleCancel = (e) => {
        navigate("/");
    }

    return (
        <Formik
            validationSchema={schema}
            initialValues={
                {
                    tabInvite: {
                        email: "",
                        language: ''
                    }
                }
            }
            onSubmit={(values, actions) => {
                backend.api.inviteUser(
                    {
                        email: values.tabInvite.email,
                        languageId: values.tabInvite.language,
                        message: values.tabInvite.message,
                    }, (response) => {
                        navigate("/", {state: {message: t('system.inviteSuccessful')}});
                    }, (error) => {
                        if (error.data?.message === "invitation_email_exists") {
                            actions.setFieldError("tabInvite.email", "invitation_email_exists");
                            actions.setSubmitting(false);
                        } else {
                            navigate("/error", backend.api.getErrorState(error));
                        }
                    });
            }}>{({handleSubmit, handleChange, errors, values, isSubmitting, dirty, isValid}) => (
            <Form className={"p-0  " + styles.tabs} onSubmit={handleSubmit} autoComplete={"off"}>
                <Row>
                    <Tabs
                        defaultActiveKey="basic"
                        transition={true}
                        id="edit-tab"
                        className={"mb-0 bg-primary"}
                    >
                        <Tab eventKey="basic" title={t('invite.header')}
                             tabClassName={!!errors.tabInvite ? ("text-danger") : null}>
                            <Container fluid={true} className={"py-4"}>
                                <Row>
                                    <Col>
                                        <div className={"inputContainer"}>
                                            <Form.Label htmlFor="tabInvite.email"
                                                        className={styles.label}>{t('profile.email')}</Form.Label>
                                            <Form.Control type="text" name={"tabInvite.email"}
                                                          onChange={handleChange}
                                                          value={values.tabInvite.email}
                                                          isInvalid={!!errors.tabInvite?.email}/>
                                            <Form.Control.Feedback
                                                type={"invalid"} className={"px-2"}>{errors.tabInvite?.email==="invitation_email_exists"?(t('invite.emailExists')):""}</Form.Control.Feedback>
                                        </div>
                                    </Col>
                                    <Col>
                                        <div className={"inputContainer"}>
                                            <Form.Label htmlFor="tabInvite.language"
                                                        className={styles.label}>{t('profile.language')}</Form.Label>
                                            <Form.Select
                                                className={"pe-1 pt-0 pb-1"}
                                                name={"tabInvite.language"}
                                                value={values.tabInvite.language}
                                                onChange={handleChange}
                                                isInvalid={!!errors.tabInvite?.language}>
                                                {languageList}
                                            </Form.Select>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <div className={"inputContainer"}>
                                            <Form.Label htmlFor="tabInvite.message"
                                                        className={styles.label}>{t('invite.message')}</Form.Label>
                                            <Form.Control as="textarea" rows={5} name={"tabInvite.message"}
                                                          onChange={handleChange}
                                                          value={values.tabInvite.message}
                                                          isInvalid={!!errors.tabInvite?.message}/>
                                        </div>
                                    </Col>
                                </Row>
                            </Container>
                        </Tab>
                    </Tabs>
                </Row>
                <Row>
                    <div className="d-flex gap-2 p-2 justify-content-center">
                        <Button className={"websobutton"} size={"md"} variant={"danger"}
                                onClick={handleCancel}>{t('system.cancelButton')}</Button>
                        <Button className={"websobutton"} type={"submit"} disabled={isSubmitting || !dirty || !isValid} size={"md"}>
                            {isSubmitting ? (<Spinner
                                className={"me-2"}
                                as="span"
                                animation="border"
                                size="sm"
                            />) : null}{t('invite.inviteButton')}</Button>
                    </div>
                </Row>
            </Form>
        )}</Formik>);
}